import {noop} from '@benchling/js-utils';
import {Dispatch, SetStateAction} from 'react';

import {makeReactContext} from 'lib/makeReactContext';
import {ErrorBadgeError} from 'procedures/design/error-panel/ErrorBadge';
import {
  ProcedureRunTab,
  type ProcedureRunOrPlanStateSummary,
} from 'studies/redux/ProcedureRunPlanUIReduxActions';
import {ProcedureRunSelectionForAnalysis} from 'studies/typed/shared/analysis/useProcedureRunSelectionForAnalysis';

export const StudyOverviewContext = makeReactContext<{
  selectedProcedureRun: ProcedureRunOrPlanStateSummary;
  selectedProcedureRunPlan: ProcedureRunOrPlanStateSummary;
  currentProcedureRunTab: ProcedureRunTab;
  setCurrentProcedureRunTab: (procedureRunTab: ProcedureRunTab) => void;
  promotingPlanIds: Set<string>;
  selectedProcedureRunsForAnalysis: Array<ProcedureRunSelectionForAnalysis>;
  addPromotingPlanId: (planId: string) => void;
  removePromotingPlanId: (planId: string) => void;
  setSelectedProcedureRunsForAnalysis: Dispatch<SetStateAction<Array<ProcedureRunSelectionForAnalysis>>>;
  setSavePlanIfUnsavedChanges: (fn: (() => Promise<void>) | null, hasUnsavedPlanChanges?: boolean) => void;
  planErrors: Array<ErrorBadgeError>;
  setPlanErrors: (errors: Array<ErrorBadgeError>) => void;
  isProcedureRunDescriptionInEditMode: boolean;
  setIsProcedureRunDescriptionInEditMode: Dispatch<SetStateAction<boolean>>;
  isProcedureRunDesignInEditMode: boolean;
  setIsProcedureRunDesignInEditMode: Dispatch<SetStateAction<boolean>>;
}>(
  () => ({
    selectedProcedureRun: {id: null, name: null},
    selectedProcedureRunPlan: {id: null, name: null, procedureId: null},
    currentProcedureRunTab: ProcedureRunTab.OVERVIEW,
    setCurrentProcedureRunTab: noop,
    promotingPlanIds: new Set(),
    selectedProcedureRunsForAnalysis: [],
    addPromotingPlanId: noop,
    removePromotingPlanId: noop,
    setSelectedProcedureRunsForAnalysis: noop,
    setSavePlanIfUnsavedChanges: noop,
    planErrors: [],
    setPlanErrors: noop,
    isProcedureRunDescriptionInEditMode: false,
    setIsProcedureRunDescriptionInEditMode: noop,
    isProcedureRunDesignInEditMode: false,
    setIsProcedureRunDesignInEditMode: noop,
  }),
  'StudyOverviewContext'
);
